import { Injectable } from '@angular/core';
import { HardwareProduct } from '@app/shared/models/hardware-product.model';
import { Product } from '@app/shared/models/product.model';
import { VoiceProduct } from '@app/shared/models/voice-product.model';
import { MobilePhoneProduct } from '../models/mobilephone-product';
import { MbbProduct } from '../modules/mbb/models/mbb-product.model';

type ProductsWithCaptureTypes = MbbProduct | VoiceProduct | HardwareProduct | MobilePhoneProduct | Product;

@Injectable({
  providedIn: 'root',
})
export class ProductHelperService {
  constructor() {}

  static isMbbProduct = (product: ProductsWithCaptureTypes): product is MbbProduct => {
    return !!(product as MbbProduct)?.mbbSubscription;
  };

  static isMobileProduct = (product: ProductsWithCaptureTypes): product is MobilePhoneProduct => {
    return !!(product as MobilePhoneProduct)?.mobilePhoneVariant || (product as MobilePhoneProduct)?.isManualRegistration;
  };

  static isAccessoryProduct = (product: ProductsWithCaptureTypes): product is HardwareProduct => {
    return !!(product as HardwareProduct)?.equipment;
  };
}
